/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import AnalyticsService from 'cio/services/analytics';
import TagModel from 'cio/models/tag';
import { Select } from 'ember-power-select/components/power-select';

interface TagModalToggleItemArgs {
  tags: TagModel[];
  openTagModal: () => unknown;
}

export default class TagModalToggleItem extends Component<TagModalToggleItemArgs> {
  @service analytics!: AnalyticsService;

  @action
  openModal(select: Select) {
    this.analytics.track('tags', 'manage_started', { tags: this.args.tags });

    select.actions.close();
    this.args.openTagModal();
  }
}
